import { Button, DatePicker, Modal, Space } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";

export default function FilterDate({ closeModelFilter, onFilterDateChange }) {
  const [FilterDate, setFilterDate] = useState({
    start: null,
    end: null,
  });
  const handleDateChange_Start = (date) => {
    setFilterDate({
      ...FilterDate,
      start: dayjs(date).format("YYYY-MM-DD"),
    });
  };
  const handleDateChange_End = (date) => {
    setFilterDate({
      ...FilterDate,
      end: dayjs(date).format("YYYY-MM-DD"),
    });
  };

  const modelFilterSearch = () => {
    console.log("FilterDate:", FilterDate);
    if (onFilterDateChange) {
      onFilterDateChange(FilterDate); // send to parent
    }
  };
  return (
    <>
      <Space>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Space style={{ width: "100%" }}>
            ចាប់ពីថ្ងៃទី:
            <DatePicker format="DD/MM/YYYY" onChange={handleDateChange_Start} />
          </Space>
        </div>
        <div>
          <Space>
            ដល់ថ្ងៃទី:
            <DatePicker format="DD/MM/YYYY" onChange={handleDateChange_End} />
          </Space>
        </div>
      </Space>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "10px",
          justifyContent: "end",
        }}
      >
        <Space>
          <Button key="back" danger type="primary" onClick={closeModelFilter}>
            បិទ
          </Button>

          <Button type="primary" onClick={modelFilterSearch}>
            ស្វែងរក
          </Button>
        </Space>
      </div>
    </>
  );
}
